export default __webpack_public_path__ + "f84b476995a8496adce24ec672244eafc9a43686/161a231856ba99f96b16b1f91115e718.png";